<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd">
      <div class="fl" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加用户
        </router-link>
        <el-button class="m-l-10" type="primary" @click="fetchData" v-if="showWechatStatus">同步企业微信用户</el-button>
      </div>
      <!--<div class="fl w-200 m-l-30" @keyup.enter="search()">-->
      <!--<el-input placeholder="请输入用户名" v-model="keywords">-->
      <!--<el-button slot="append" icon="search" @click="search()"></el-button>-->
      <!--</el-input>-->
      <!--</div>-->
      <div class="fl w-300 m-l-30" @keyup.enter="search()">
        <el-input placeholder="请输入用户名" v-model="keywords"></el-input>
      </div>
      <div class="fl m-l-20">
        <el-button type="primary" @click="search">搜索</el-button>
      </div>
      <div class="fr">
        <el-button @click="upUserModel">导入</el-button>
      </div>
      <div class="fr m-r-20">
        <el-button @click="downUserModel">模板下载</el-button>
      </div>
    </div>
    <el-table
        :data="tableData"
        style="width: 100%"
        @selection-change="selectItem">
      <el-table-column
          type="selection"
          width="50">
      </el-table-column>
      <!-- <el-table-column
      prop="s_name"
      label="所属组织架构">
      </el-table-column>
      <el-table-column
      label="用户名"
      prop="username"
      width="200">
      </el-table-column>
      <el-table-column
      label="备注"
      prop="remark"
      width="200">
      </el-table-column>
      <el-table-column
      label="状态"
      width="100">
        <template scope="scope">
          <div>
            {{ scope.row.status | status }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
          prop="realname"
          label="姓名">
      </el-table-column>
      <el-table-column
          prop="position"
          label="职位">
      </el-table-column>
      <el-table-column
          prop="structure"
          label="所属部门">
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机">
      </el-table-column>
      <el-table-column
          prop="email"
          label="邮箱">
      </el-table-column>
      <el-table-column
          label="企业号状态"
          v-if="showWechatStatus">
        <template scope="scope">
          {{ scope.row.subscribe_status | wechatStatus }}
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="200">
        <template scope="scope">
          <div>
            <span v-show="editShow">
              <router-link :to="{ name: 'usersEdit', params: { id: scope.row.id }}" class="btn-link edit-btn">
            编辑
              </router-link>
            </span>
            <span v-show="deleteShow">
              <el-button size="small" @click="confirmDelete(scope.row)">删除</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'admin/users'"></btnGroup>
      <div class="block pages">
        <el-pagination
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :page-size="limit"
            :current-page="currentPage"
            :total="dataCount">
        </el-pagination>
      </div>
    </div>
    <el-upload
      class="user-import"
      :headers="headers"
      :action="host+uploadUrl"
      :on-success="handleSuccess"
      :on-error="handleError"
      style="display:none"
      >
    </el-upload>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/normal/btn-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        loading: false,
        limit: 15,
        showWechatStatus: false,
        host: '',
        uoloadUrl: '',
        headers: {}
      }
    },
    filters: {
      wechatStatus(value) {
        let status = ''
        switch (value) {
          case 1:
            status = '已关注'
            break
          case 2:
            status = '已冻结'
            break
          case 4:
            status = '未关注'
            break
          default:
            status = '未知状态'
            break
        }
        return status
      }
    },
    methods: {
      handleSuccess(res, file, fileList) {
        if (res.code === 200) {
          let tips = `导入数据成功${res.data.success}条，失败${res.data.fail}条`
          _g.toastMsg(this, 'success', tips)
          setTimeout(() => {
            _g.reloadPage(this)
          }, 1000)
          return
        }
        _g.dealError(this, res)
      },
      handleError(res, file, fileList) {
        _g.toastMsg('导入失败，请重试')
      },
      search() {
        router.push({ path: '/users/list', query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
//        console.log('val = ', val)
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: '/users/list', query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除该用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiDelete('admin/users/', item.id).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '删除成功')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
      },
      fetchData() {
        this.loading = true
        this.apiGet('admin/users/fetch').then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '同步成功！')
            this.getAllUsers()
          } else {
            _g.dealError(this, res)
            this.loading = false
          }
        })
      },
      getAllUsers() {
        this.loading = true
        this.apiGet('admin/users?keywords=' + this.keywords + '&page=' + this.currentPage + '&limit=' + this.limit).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
            this.showWechatStatus = res.data.use_wechat_work
            if (res.data.use_wechat_work && res.data.use_wechat_work == 0) {
              this.showWechatStatus = false
            } else {
              this.showWechatStatus = true
            }
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      },
      downUserModel() {
        // 模板下载
        this.downLoadUrl = HOST + `/static/userTemp.xlsx`
        let newWindow = window.open(this.downLoadUrl, '_blank')
        // setTimeout(() => {
        //   newWindow.close()
        // }, 1000)
      },
      upUserModel() {
        // 导入模板
        this.uploadUrl = `/admin/users/importlist`
        let base64 = window.btoa((new Date()).getTime())
        let token = Lockr.get('token') + '%' + base64
        this.headers = {
          token: token
        }
        document.querySelector('.user-import input[name=file]').click()
      }
    },
    created() {
      this.init()
      this.host = HOST
    },
    computed: {
      addShow() {
        return _g.getHasRule('')
      },
      editShow() {
        return _g.getHasRule('')
      },
      deleteShow() {
        return _g.getHasRule('')
      }
    },
    watch: {
      '$route' (to, from) {               // 监听路由改变
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?674380a5